var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createSlice } from '@reduxjs/toolkit';
import { loadingSlice } from './LoadingStore';
export var defaultNotificationState = {
    data: [],
    meta: {},
};
// REDUCERS
var getNotificationsReducer = function (state, action) {
    return {
        data: action.payload.data,
        meta: action.payload.meta,
    };
};
var dismissAllNotificationsReducer = function () {
    return {
        data: [],
        meta: {},
    };
};
var dismissNotificationReducer = function (state, action) {
    var updatedData = state.data.filter(function (notification) { return !action.payload.communique_ids.includes(notification.id); });
    return __assign(__assign({}, state), { data: updatedData });
};
export var notificationSlice = createSlice({
    name: 'notification',
    initialState: defaultNotificationState,
    reducers: {
        getNotifications: getNotificationsReducer,
        dismissAllNotifications: dismissAllNotificationsReducer,
        dismissNotification: dismissNotificationReducer,
    },
});
// ACTUAL ACTIONS
// a place to make the actions more complex if necessary
var getNotifications = function (dispatch, payload, apiClient) { return __awaiter(void 0, void 0, void 0, function () {
    var result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch(loadingSlice.actions.setLoading({ action: 'getNotifications' }));
                return [4 /*yield*/, apiClient().getNotifications(payload)];
            case 1:
                result = _a.sent();
                dispatch(notificationSlice.actions.getNotifications(result));
                dispatch(loadingSlice.actions.unsetLoading({ action: 'getNotifications' }));
                return [2 /*return*/];
        }
    });
}); };
var dismissAllNotifications = function (dispatch, payload, apiClient) { return __awaiter(void 0, void 0, void 0, function () {
    var result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch(loadingSlice.actions.setLoading({ action: 'dismissAllNotifications' }));
                return [4 /*yield*/, apiClient().dismissAllNotifications()];
            case 1:
                result = _a.sent();
                if ((result === null || result === void 0 ? void 0 : result.acknowledged_count) > 0) {
                    dispatch(notificationSlice.actions.dismissAllNotifications());
                }
                else {
                    console.error('Error dismissing notifications. No acknowledged count returned or count is zero.', result);
                }
                dispatch(loadingSlice.actions.unsetLoading({ action: 'dismissAllNotifications' }));
                return [2 /*return*/];
        }
    });
}); };
var dismissNotification = function (dispatch, payload, apiClient) { return __awaiter(void 0, void 0, void 0, function () {
    var payloadWithIds, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch(loadingSlice.actions.setLoading({ action: 'dismissNotification' }));
                payloadWithIds = {
                    communique_ids: [payload],
                };
                return [4 /*yield*/, apiClient().dismissNotification(payloadWithIds)];
            case 1:
                result = _a.sent();
                if ((result === null || result === void 0 ? void 0 : result.acknowledged_count) > 0) {
                    dispatch(notificationSlice.actions.dismissNotification(payloadWithIds));
                }
                else {
                    console.error('Error dismissing notification. No acknowledged count returned or count is zero.', result);
                }
                dispatch(loadingSlice.actions.unsetLoading({ action: 'dismissNotification' }));
                return [2 /*return*/];
        }
    });
}); };
export var notificationActions = function (dispatch, apiClient) {
    return {
        // dispatching plain actions
        getNotifications: function (payload) { return getNotifications(dispatch, payload, apiClient); },
        dismissAllNotifications: function (payload) { return dismissAllNotifications(dispatch, payload, apiClient); },
        dismissNotification: function (payload) { return dismissNotification(dispatch, payload, apiClient); },
    };
};
